import { ChangeEvent, KeyboardEvent, useRef } from "react";
import { actionBarMinWidthWrapper } from "src/components/common/common";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { XButtonForm } from "src/components/common/form/XButtonForm";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";

import { useSYS4030_R01Store } from "./Store_SYS4030_R01";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

export const SYS4030_R01SearchSection = ({ onEnterKeyDown }: Props) => {

	const { SYS4030_R01Filter, setSYS4030_R01Filter } = useSYS4030_R01Store();
	const { compCdList, wmsCdList, inoutBoundList, yesNoList } = useCommonCodeStore();

  return (
    <SearchSectionForm>
		{/* SYS4030_R01Filter : {JSON.stringify(SYS4030_R01Filter)} */}
		<SearchDropDownForm
			label="사업장"
			value={SYS4030_R01Filter.compCd}
			optionList={compCdList}
			onChangeItem={(selectedItem) => setSYS4030_R01Filter({ compCd: selectedItem?.compCd || '' })}
		/>
		<SearchDropDownForm
			label="물류센터"
			value={SYS4030_R01Filter.logicCenter}
			optionList={wmsCdList}
			onChangeItem={(selectedItem) => setSYS4030_R01Filter({ logicCenter: selectedItem?.minorCd || '' })}
		/>
		<SearchDropDownForm
			label="공정유형"
			value={SYS4030_R01Filter.inoutType}
			optionList={inoutBoundList}
			onChangeItem={(selectedItem) => setSYS4030_R01Filter({ inoutType: selectedItem?.minorCd || '' })}
		/>
		<SearchDropDownForm
			label="사용여부"
			value={SYS4030_R01Filter.useYn || 'all'}
			optionList={yesNoList}
			onChangeItem={(selectedItem) => setSYS4030_R01Filter({ useYn: selectedItem?.minorCd || '' })}
		/>
	</SearchSectionForm>
  );
};